import script from "./NotifyVideoEngineChangePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifyVideoEngineChangePopup.vue?vue&type=script&setup=true&lang=ts"

import "./NotifyVideoEngineChangePopup.vue?vue&type=style&index=0&id=1c866835&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c866835"]])

export default __exports__